import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Team from './team';
import TeamModal from './team_modal';

import { get, post, put, deleteRequest } from 'helpers/api';
import { debounce } from 'lodash';
import './teams.scss';

export default function Teams({ searchUrl, teamsUrl, teamsV2, updatePreview }) {
  const [teams, setTeams] = useState([]);
  const [newTeamName, setNewTeamName] = useState('');
  const [teamModalOpen, setTeamModalOpen] = useState(false);

  if (!teamsUrl) return null;

  const handleUpdatePreview = (...args) => {
    if (updatePreview) updatePreview(args);
  };

  function closeModal() {
    setTeamModalOpen(false);
    setNewTeamName('');
  }

  useEffect(() => {
    getTeams();
  }, []);

  const renderTeams = () => {
    return teams.map((team) => {
      return (
        <Team
          deleteTeam={deleteTeam}
          editTeam={editTeam}
          id={team.id}
          key={team.id}
          name={team.name}
          teamsUrl={teamsUrl}
          updatePreview={handleUpdatePreview}
        />
      );
    });
  };

  const getTeams = async () => {
    const response = await get(teamsUrl);

    setTeams(response.emailTeams);
  };

  const createTeam = async () => {
    setTeamModalOpen(false);
    await post(teamsUrl, { emailTeam: { name: newTeamName } }).then((response) => {
      const newTeam = { id: response.emailTeam.id, name: response.emailTeam.name };
      setTeams([...teams, newTeam]);
      handleUpdatePreview({ emailTeams: [...teams, newTeam] });
      setNewTeamName('');
    });
  };

  const editTeam = async (id, name) => {
    await put(`${teamsUrl}/${id}`, { emailTeam: { name: name } }).then((response) => {
      const updatedTeams = teams.map((team) => {
        if (team.id === id) {
          team.name = response.emailTeam.name;
        }
        return team;
      });
      setTeams(updatedTeams);
      handleUpdatePreview({ emailTeams: updatedTeams });
    });
  };

  const deleteTeam = async (id) => {
    await deleteRequest(`${teamsUrl}/${id}`).then(() => {
      const updatedTeams = teams.filter(team => team.id !== id);
      setTeams(updatedTeams);
      handleUpdatePreview({ emailTeams: updatedTeams });
    });
  };

  const teamIds = useMemo(() => {
    return teams.map(t => t.id);
  }, [teams]);

  const searchTeams = debounce((searchText, callback) => {
    const url = `${searchUrl}?search_text=${searchText}`;
    get(url).then(({ emailTeams }) => {
      callback(emailTeams.filter(t => !teamIds.includes(t.id)));
    });
  }, 250);

  const selectTeam = (team) => {
    const updatedTeams = [...teams, team];

    post(`${teamsUrl}/${team.id}/connect_team`).then(() => {
      closeModal();
      setTeams(updatedTeams);
      handleUpdatePreview({ emailTeams: updatedTeams });
    });
  };

  return (
    <div className="teams mb-5">
      <TeamModal
        editOrCreateTeam={createTeam}
        modalOpen={teamModalOpen}
        newTeam={true}
        setTeamName={setNewTeamName}
        teamName={newTeamName}
        onModalClose={closeModal}
        onSearchTeams={teamsV2 && searchTeams}
        onTeamSelect={selectTeam}
      />
      <div className="teams-label">
        Email Footer Contacts
      </div>
      {renderTeams()}
      <button className="btn" type="button" onClick={() => setTeamModalOpen(true)}>+ Create Contact Header</button>
    </div>
  );
}

Teams.propTypes = {
  searchUrl: PropTypes.string,
  teamsUrl: PropTypes.string,
  teamsV2: PropTypes.bool,
  updatePreview: PropTypes.func
};
